import React from 'react';
import { HelpPopover } from '@gravity-ui/components';
import { cn } from '../../classname';
import './FormRow.css';
const b = cn('form-row');
export const FormRow = ({ className, label, help, control, controlClassName, }) => {
    return (React.createElement("div", { className: b(null, [className]) },
        React.createElement("div", { className: b('label') },
            React.createElement("span", { className: b('label-text') }, label),
            help && React.createElement(HelpPopover, { content: help, className: b('label-help') })),
        React.createElement("div", { className: b('control', [controlClassName]) }, control)));
};
